import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-league',
  standalone: true,
  imports: [],
  templateUrl: './league.component.html',
  styleUrl: './league.component.scss'
})
export class LeagueComponent {
  @Input() season!: string;
}
